import React from 'react';

const cases = [
  {
    id: 1,
    name: "Clarice",
    urgency: "Alta urgencia",
    city: "Itajai - SC",
    summary: "Viuva, com duas filhas adolescentes, enfrentando problema cardiaco e necessidade de apoio imediato.",
    needs: ["Cesta basica", "Apoio financeiro", "Visita", "Oracao"],
    saint: "Sao Rafael",
  },
  {
    id: 2,
    name: "Familia Silva",
    urgency: "Urgente",
    city: "Balneario Camboriu - SC",
    summary: "Familia em dificuldade financeira precisando de acolhimento e suporte pratico.",
    needs: ["Alimentos", "Visita", "Oracao"],
    saint: "Sao Jose",
  },
  {
    id: 3,
    name: "Joao",
    urgency: "Acompanhamento",
    city: "Navegantes - SC",
    summary: "Paciente em recuperacao, precisando de visitas e continuidade no cuidado.",
    needs: ["Visita", "Escuta", "Oracao"],
    saint: "Santa Teresinha",
  },
];

const missionSteps = [
  "Vou agir com respeito",
  "Nao vou julgar",
  "Vou levar presenca",
  "Vou acolher com amor",
];

const missionKit = [
  { title: "Agua benta", description: "Sinal de esperanca e fe" },
  { title: "Terco", description: "Apoio para oracao simples" },
  { title: "Mensagem", description: "Palavra breve que consola" },
  { title: "Presenca", description: "O maior presente da visita" },
];

const stats = [
  { label: "Missoes realizadas", value: "12" },
  { label: "Pessoas ajudadas", value: "37" },
  { label: "Voluntarios ativos", value: "18" },
];

const howItWorks = [
  {
    step: "1",
    title: "Cadastre-se no SantoGram",
    description: "Crie sua conta gratuitamente em poucos segundos.",
  },
  {
    step: "2",
    title: "Veja os casos ou indique alguem",
    description: "Encontre pessoas que precisam de ajuda ou indique alguem que voce conhece.",
  },
  {
    step: "3",
    title: "Participe de uma missao",
    description: "Escolha visitar, ajudar ou rezar. Assuma o compromisso e va em missao.",
  },
  {
    step: "4",
    title: "Registre o acompanhamento",
    description: "Apos a visita, conte como foi e indique se precisa de continuidade.",
  },
];

const MissaoCaminhoDosSantos: React.FC = () => {
  const handleCTA = () => {
    window.location.href = '/signup?redirect=/missoes';
  };

  return (
    <div className="min-h-screen bg-stone-50 text-stone-800">
      <header className="sticky top-0 z-50 border-b border-stone-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6">
          <div className="flex items-center gap-6">
            <img src="/santogram_logo.png" alt="SantoGram" className="h-14 w-14" />
            <div>
              <div className="text-[11px] font-semibold uppercase tracking-[0.25em] text-amber-700 sm:text-xs">SantoGram</div>
              <h1 className="text-xl font-semibold tracking-tight sm:text-2xl">Missao Caminho dos Santos</h1>
            </div>
          </div>
          <nav className="hidden gap-6 text-sm md:flex">
            <a href="#casos" className="hover:text-amber-700">Casos</a>
            <a href="#como-funciona" className="hover:text-amber-700">Como funciona</a>
            <a href="#kit" className="hover:text-amber-700">Kit da missao</a>
          </nav>
          <div className="flex items-center gap-3">
            <a href="/signin?redirect=/missoes" className="hidden text-sm font-medium text-stone-600 hover:text-amber-700 sm:block">
              Entrar
            </a>
            <button
              onClick={handleCTA}
              className="rounded-2xl bg-amber-700 px-5 py-2.5 text-sm font-semibold text-white transition hover:scale-[1.02]"
            >
              Cadastre-se
            </button>
          </div>
        </div>
      </header>

      <main>
        {/* Hero */}
        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-amber-100 via-white to-emerald-50" />
          <div className="relative mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:px-6 sm:py-16 md:grid-cols-2 md:py-24">
            <div className="flex flex-col justify-center">
              <span className="mb-4 inline-flex w-fit rounded-full bg-white px-4 py-2 text-xs font-medium text-amber-800 shadow-sm ring-1 ring-amber-200 sm:text-sm">
                Leve presenca, cuidado e esperanca
              </span>
              <h2 className="text-3xl font-semibold tracking-tight text-stone-900 sm:text-4xl md:text-6xl">
                Uma area do SantoGram para transformar fe em acao.
              </h2>
              <p className="mt-4 max-w-xl text-base leading-7 text-stone-600 sm:mt-5 sm:text-lg sm:leading-8">
                Encontre pessoas que precisam de ajuda, participe de missoes, indique casos reais e acompanhe o impacto com uma experiencia simples, acolhedora e espiritual.
              </p>
              <div className="mt-7 grid gap-3 sm:mt-8 sm:flex sm:flex-wrap sm:gap-4">
                <button
                  onClick={handleCTA}
                  className="rounded-2xl bg-amber-700 px-6 py-3 text-center text-sm font-semibold text-white shadow-sm transition hover:scale-[1.02]"
                >
                  Quero participar
                </button>
                <a
                  href="#como-funciona"
                  className="rounded-2xl bg-white px-6 py-3 text-center text-sm font-semibold text-stone-800 ring-1 ring-stone-200 transition hover:bg-stone-100"
                >
                  Como funciona?
                </a>
              </div>
            </div>

            <div className="grid gap-4 sm:grid-cols-2">
              {stats.map((stat) => (
                <div key={stat.label} className="rounded-3xl bg-white p-5 shadow-sm ring-1 ring-stone-200 sm:p-6">
                  <div className="text-2xl font-semibold text-stone-900 sm:text-3xl">{stat.value}</div>
                  <div className="mt-2 text-sm text-stone-600">{stat.label}</div>
                </div>
              ))}
              <div className="rounded-3xl bg-stone-900 p-5 text-white shadow-sm sm:p-6 sm:col-span-2">
                <div className="text-xs uppercase tracking-[0.2em] text-amber-300 sm:text-sm">Proposito</div>
                <p className="mt-3 text-base leading-7 text-stone-200 sm:text-lg sm:leading-8">
                  Levar presenca, cuidado e esperanca para pessoas em momentos de dor, unindo ajuda pratica com apoio espiritual.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Como funciona */}
        <section id="como-funciona" className="bg-white py-12 sm:py-16">
          <div className="mx-auto max-w-7xl px-4 sm:px-6">
            <div className="mb-10 text-center">
              <div className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-700 sm:text-sm">Passo a passo</div>
              <h3 className="mt-2 text-2xl font-semibold tracking-tight sm:text-3xl">Como funciona</h3>
              <p className="mx-auto mt-3 max-w-2xl text-sm leading-7 text-stone-600 sm:text-base">
                Em poucos passos voce ja pode fazer a diferenca na vida de alguem.
              </p>
            </div>

            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
              {howItWorks.map((item) => (
                <div key={item.step} className="rounded-3xl bg-stone-50 p-6 ring-1 ring-stone-200">
                  <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-amber-700 text-sm font-bold text-white">
                    {item.step}
                  </div>
                  <h4 className="mt-4 text-lg font-semibold text-stone-900">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-stone-600">{item.description}</p>
                </div>
              ))}
            </div>

            <div className="mt-10 text-center">
              <button
                onClick={handleCTA}
                className="rounded-2xl bg-amber-700 px-8 py-3 text-sm font-semibold text-white shadow-sm transition hover:scale-[1.02]"
              >
                Criar minha conta e comecar
              </button>
            </div>
          </div>
        </section>

        {/* Casos ativos (preview) */}
        <section id="casos" className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16">
          <div className="mb-8 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <div className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-700 sm:text-sm">Casos ativos</div>
              <h3 className="text-2xl font-semibold tracking-tight sm:text-3xl">Pessoas que precisam de ajuda</h3>
            </div>
            <p className="max-w-2xl text-sm leading-7 text-stone-600 sm:text-base">
              Estes sao alguns dos casos ativos. Cadastre-se para ver todos e participar.
            </p>
          </div>

          <div className="grid gap-5 lg:grid-cols-3">
            {cases.map((item) => (
              <article key={item.id} className="rounded-3xl bg-white p-5 shadow-sm ring-1 ring-stone-200 transition hover:-translate-y-1 sm:p-6">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h4 className="text-lg font-semibold text-stone-900 sm:text-xl">{item.name}</h4>
                    <p className="mt-1 text-sm text-stone-500">{item.city}</p>
                  </div>
                  <span className="rounded-full bg-rose-50 px-3 py-1 text-[11px] font-semibold text-rose-700 ring-1 ring-rose-200 sm:text-xs">
                    {item.urgency}
                  </span>
                </div>

                <p className="mt-4 text-sm leading-7 text-stone-600">{item.summary}</p>

                <div className="mt-5">
                  <div className="text-sm font-medium text-stone-800">Necessidades</div>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {item.needs.map((need) => (
                      <span key={need} className="rounded-full bg-stone-100 px-3 py-1 text-[11px] font-medium text-stone-700 sm:text-xs">
                        {need}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="mt-5 rounded-2xl bg-amber-50 p-4 text-sm text-amber-900 ring-1 ring-amber-100">
                  Santo que acompanha esta missao: <strong>{item.saint}</strong>
                </div>

                <button
                  onClick={handleCTA}
                  className="mt-6 w-full rounded-2xl bg-stone-900 px-4 py-3 text-sm font-semibold text-white transition hover:opacity-95"
                >
                  Cadastre-se para participar
                </button>
              </article>
            ))}
          </div>
        </section>

        {/* Compromisso da missao */}
        <section className="bg-white py-12 sm:py-16">
          <div className="mx-auto max-w-7xl px-4 sm:px-6">
            <div className="mx-auto max-w-3xl">
              <div className="rounded-3xl bg-stone-900 p-6 text-white shadow-sm sm:p-8">
                <div className="text-center">
                  <div className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-300 sm:text-sm">Nosso compromisso</div>
                  <h4 className="mt-2 text-xl font-semibold sm:text-2xl">Cada voluntario assume estes valores</h4>
                  <p className="mt-3 text-sm leading-7 text-stone-300 sm:text-base">
                    Antes de participar de qualquer missao, todo voluntario se compromete com respeito e acolhimento.
                  </p>
                </div>
                <div className="mt-8 grid gap-4 sm:grid-cols-2">
                  {missionSteps.map((step, index) => (
                    <div
                      key={step}
                      className="flex items-center gap-4 rounded-2xl bg-white/5 p-4 ring-1 ring-white/10"
                    >
                      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-amber-600 text-sm font-bold text-white">
                        {index + 1}
                      </div>
                      <span className="text-sm font-medium text-stone-100">{step}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Kit da missao */}
        <section id="kit" className="bg-stone-900 py-12 text-white sm:py-16">
          <div className="mx-auto max-w-7xl px-4 sm:px-6">
            <div className="mb-8 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
              <div>
                <div className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-300 sm:text-sm">Kit da missao</div>
                <h3 className="text-2xl font-semibold tracking-tight sm:text-3xl">O que levar em uma visita</h3>
              </div>
              <p className="max-w-2xl text-sm leading-7 text-stone-300 sm:text-base">
                O foco nao e complexidade, mas presenca significativa.
              </p>
            </div>

            <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4 sm:gap-6">
              {missionKit.map((item) => (
                <div key={item.title} className="rounded-3xl bg-white/5 p-5 ring-1 ring-white/10 sm:p-6">
                  <div className="text-lg font-semibold sm:text-xl">{item.title}</div>
                  <p className="mt-3 text-sm leading-7 text-stone-300">{item.description}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 rounded-3xl bg-amber-600/10 p-5 text-sm leading-7 text-amber-100 ring-1 ring-amber-500/20 sm:p-6">
              Lembre-se: a maior ajuda nem sempre e material. Muitas vezes, o que cura primeiro e a atencao, a escuta e a presenca.
            </div>
          </div>
        </section>

        {/* CTA final */}
        <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24">
          <div className="rounded-3xl bg-gradient-to-br from-amber-50 to-emerald-50 p-8 text-center ring-1 ring-amber-200 sm:p-12">
            <h3 className="text-2xl font-semibold tracking-tight text-stone-900 sm:text-3xl">
              Pronto para transformar fe em acao?
            </h3>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-stone-600 sm:text-base">
              Cadastre-se no SantoGram, veja os casos ativos, indique alguem que precisa de ajuda ou participe de uma missao. Sua presenca faz a diferenca.
            </p>
            <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center sm:gap-4">
              <button
                onClick={handleCTA}
                className="rounded-2xl bg-amber-700 px-8 py-3 text-sm font-semibold text-white shadow-sm transition hover:scale-[1.02]"
              >
                Criar minha conta gratuita
              </button>
              <a
                href="/signin?redirect=/missoes"
                className="rounded-2xl bg-white px-8 py-3 text-sm font-semibold text-stone-800 ring-1 ring-stone-200 transition hover:bg-stone-100"
              >
                Ja tenho conta
              </a>
            </div>
          </div>
        </section>
      </main>

      <footer className="border-t border-stone-200 bg-white">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-8 text-sm text-stone-500 sm:px-6 md:flex-row md:items-center md:justify-between">
          <div>&copy; SantoGram &bull; Missao Caminho dos Santos</div>
          <div className="flex flex-wrap gap-4">
            <span className="cursor-pointer hover:text-amber-700">Politica de cuidado</span>
            <span className="cursor-pointer hover:text-amber-700">Privacidade</span>
            <span className="cursor-pointer hover:text-amber-700">Contato</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MissaoCaminhoDosSantos;
